import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import s from './HeroSection.module.css';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';
import { motion } from 'framer-motion';
import rectangle5969 from './images/Rectangle 5969.png';
import rectangle5970 from './images/Rectangle 5970.png';
import rectangle5971 from './images/Rectangle 5971.png';
import rectangle5972 from './images/Rectangle 5972.png';
import rectangle5973 from './images/Rectangle 5973.png';
import rectangle5974 from './images/header-main-logo (1) 1.png';
import rectangle5975 from './images/Rectangle 5978.png';
import rectangle5976 from './images/Rectangle 5975.png';
import dashboard from './images/dashboard.svg';
import StartButton from '../shared/start-button/StartButton';
import IconSpark from '../../../shared/ui/icons/IconSpark';
import iconCheck from './images/Check Circle Icon copy.svg';
import LandingPageVideo from './videos/LandingPage.mp4';
const HeroSection = () => {
    const navigate = useNavigate();
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [uploadedImage, setUploadedImage] = useState<string | null>(null);

    const handleRequestDemo = () => {
        navigate('/auth');
    };

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file && file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setUploadedImage(e.target?.result as string);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };

    const handleRemoveImage = () => {
        setUploadedImage(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, []);

    return (
        <div className={s.container}>
            <div className={s.flexRow}>
                <div className={s.topContent}>
                    <OptimizedMotionH1 className={s.title} type="slide-left" delay={0.4}>
                        Your Brand.
                        <br />
                        <span className={s.title_span}>Simplee Better.</span>
                    </OptimizedMotionH1>

                    <OptimizedMotionP className={s.subtitle} type="slide-left" delay={0.6}>
                        Make your products look premium and consistent everywhere — automatically.
                        <br />
                        Upload your product once — SimpleeCreate generates on-brand visuals,
                        mockups, and ads for every platform in seconds.
                    </OptimizedMotionP>

                    <div className={s.featuresList}>
                        <OptimizedMotionP type="slide-left" delay={0.8} className={s.featureItem}>
                            <div className={s.checkIcon}>
                                <img src={iconCheck} alt="iconCheck" />
                            </div>
                            <span className={s.featureText}>
                                Writes exactly like your brand — every time
                            </span>
                        </OptimizedMotionP>
                        <OptimizedMotionP type="slide-left" delay={1.0} className={s.featureItem}>
                            <div className={s.checkIcon}>
                                <img src={iconCheck} alt="iconCheck" />
                            </div>
                            <span className={s.featureText}>
                                Turn your templates into real products
                            </span>
                        </OptimizedMotionP>
                        <OptimizedMotionP type="slide-left" delay={1.2} className={s.featureItem}>
                            <div className={s.checkIcon}>
                                <img src={iconCheck} alt="iconCheck" />
                            </div>
                            <span className={s.featureText}>One input — endless opportunities</span>
                        </OptimizedMotionP>
                        <OptimizedMotionP type="slide-left" delay={1.4} className={s.featureItem}>
                            <div className={s.checkIcon}>
                                <img src={iconCheck} alt="iconCheck" />
                            </div>
                            <span className={s.featureText}>
                                Designed to adapt to every brand identity
                            </span>
                        </OptimizedMotionP>
                    </div>
                </div>

                <video
                    className={s.heroVideo}
                    src={LandingPageVideo}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="auto"
                    controls={false}
                    controlsList="nodownload noplaybackrate noremoteplayback nofullscreen"
                    disablePictureInPicture
                />
            </div>

            {/* <div className={s.inputSection}>
                <OptimizedMotionH1 type="slide-up" delay={1.6} className={s.inputSectionTitle}>
                    What do you want your audience to see today?
                </OptimizedMotionH1>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 1.8 }}
                    className={s.inputContainer}
                >
                    <textarea
                        className={s.inputTextarea}
                        placeholder="Describe your product or brand — we'll turn it into content magic..."
                    />
                    <div className={s.inputActions}>
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept="image/*"
                            onChange={handleFileUpload}
                            style={{ display: 'none' }}
                        />

                        {!uploadedImage ? (
                            <button className={s.uploadButton} onClick={handleUploadClick}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                >
                                    <path
                                        d="M16.875 3.125H3.125C2.79348 3.125 2.47554 3.2567 2.24112 3.49112C2.0067 3.72554 1.875 4.04348 1.875 4.375V15.625C1.875 15.9565 2.0067 16.2745 2.24112 16.5089C2.47554 16.7433 2.79348 16.875 3.125 16.875H16.875C17.2065 16.875 17.5245 16.7433 17.7589 16.5089C17.9933 16.2745 18.125 15.9565 18.125 15.625V4.375C18.125 4.04348 17.9933 3.72554 17.7589 3.49112C17.5245 3.2567 17.2065 3.125 16.875 3.125ZM16.875 4.375V12.4023L14.8383 10.3664C14.7222 10.2503 14.5844 10.1582 14.4327 10.0954C14.281 10.0325 14.1185 10.0002 13.9543 10.0002C13.7901 10.0002 13.6276 10.0325 13.4759 10.0954C13.3242 10.1582 13.1864 10.2503 13.0703 10.3664L11.5078 11.9289L8.07031 8.49141C7.83592 8.25716 7.5181 8.12558 7.18672 8.12558C6.85534 8.12558 6.53752 8.25716 6.30312 8.49141L3.125 11.6695V4.375H16.875ZM3.125 13.4375L7.1875 9.375L13.4375 15.625H3.125V13.4375ZM16.875 15.625H15.2055L12.393 12.8125L13.9555 11.25L16.875 14.1703V15.625ZM11.25 7.8125C11.25 7.62708 11.305 7.44582 11.408 7.29165C11.511 7.13748 11.6574 7.01732 11.8287 6.94636C12 6.87541 12.1885 6.85684 12.3704 6.89301C12.5523 6.92919 12.7193 7.01848 12.8504 7.14959C12.9815 7.2807 13.0708 7.44775 13.107 7.6296C13.1432 7.81146 13.1246 7.99996 13.0536 8.17127C12.9827 8.34257 12.8625 8.48899 12.7083 8.592C12.5542 8.69502 12.3729 8.75 12.1875 8.75C11.9389 8.75 11.7004 8.65123 11.5246 8.47541C11.3488 8.2996 11.25 8.06114 11.25 7.8125Z"
                                        fill="#7545ED"
                                    />
                                </svg>
                                Upload image
                            </button>
                        ) : (
                            <div className={s.imagePreview}>
                                <img
                                    src={uploadedImage}
                                    alt="Uploaded"
                                    className={s.previewImage}
                                />
                                <button className={s.removeImageButton} onClick={handleRemoveImage}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                                            fill="white"
                                        />
                                    </svg>
                                </button>
                            </div>
                        )}

                        <button className={s.generateButton}>
                            <IconSpark width={20} height={20} />
                            Generate
                        </button>
                    </div>
                </motion.div>
            </div> */}

            <OptimizedMotionH1 type="slide-left" delay={0.3} className={s.title2}>
                Trusted by brands that know
                <br />
                <span className={s.title2_span}>results start with visuals </span>
            </OptimizedMotionH1>

            <div className={s.partnersWrapper}>
                <a
                    href="https://sonyinteractive.com/en/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={s.partnerLogoWrapper}
                >
                    <img src={rectangle5969} alt="Partner Logo" className={s.partnerLogo} />
                </a>
                <a
                    href="https://www.htc.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={s.partnerLogoWrapper}
                >
                    <img src={rectangle5970} alt="Partner Logo" className={s.partnerLogo} />
                </a>
                <a
                    href="https://www.madcatz.com/en/Home/Index"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={s.partnerLogoWrapper}
                >
                    <img src={rectangle5971} alt="Partner Logo" className={s.partnerLogo} />
                </a>
                <a
                    href="https://www.happyvibes.life/?srsltid=AfmBOorN7wCp-etofTD0HLb8404JfiRsXA1W0mJek5p2yuTiDgrKyI-M"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={s.partnerLogoWrapper}
                >
                    <img src={rectangle5972} alt="Partner Logo" className={s.partnerLogo} />
                </a>
                <a
                    href="https://ca.drsquatch.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={s.partnerLogoWrapper}
                >
                    <img src={rectangle5973} alt="Partner Logo" className={s.partnerLogo} />
                </a>
                <a
                    href="https://www.westerndigital.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={s.partnerLogoWrapper}
                >
                    <img src={rectangle5974} alt="Partner Logo" className={s.partnerLogo} />
                </a>
                <a
                    href="https://signus.ai"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={s.partnerLogoWrapper}
                >
                    <img src={rectangle5975} alt="Partner Logo" className={s.partnerLogo} />
                </a>
                <a
                    href="https://glytchenergy.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={s.partnerLogoWrapper}
                >
                    <img src={rectangle5976} alt="Partner Logo" className={s.partnerLogo} />
                </a>
            </div>
        </div>
    );
};

export default HeroSection;
